var map = {
	"./ant.png": "1caf",
	"./baby-chick.png": "0e2d",
	"./bat.png": "87aa",
	"./bbq.png": "cbcc",
	"./bear.png": "e8ac",
	"./beaver.png": "002b",
	"./bison.png": "3a8c",
	"./black-cat.png": "220b",
	"./blowfish.png": "cd6e",
	"./boar.png": "5dc6",
	"./bug.png": "9d0d",
	"./butterfly.png": "f118",
	"./camel.png": "68a2",
	"./can.png": "130d",
	"./cat-face.png": "f482",
	"./cat.png": "bca3",
	"./chicken.png": "47c2",
	"./chipmunk.png": "2c1f",
	"./cow-face.png": "6a5f",
	"./cow.png": "6395",
	"./deer.png": "fe8a",
	"./dodo.png": "91e9",
	"./dog-face.png": "c471",
	"./dog.png": "33f0",
	"./dolphin.png": "65ae",
	"./duck.png": "ac84",
	"./eagle.png": "c932",
	"./elephant.png": "5cc6",
	"./feather.png": "0ef7",
	"./flamingo.png": "11f4",
	"./fly.png": "ce51",
	"./fox.png": "4e2a",
	"./frog.png": "9004",
	"./front-facing-baby-chick.png": "89c4",
	"./giraffe.png": "2fcb",
	"./gorilla.png": "c137",
	"./hedgehog.png": "3ce0",
	"./hippopotamus.png": "7512",
	"./honeybee.png": "56b5",
	"./horse-face.png": "148e",
	"./horse.png": "d296",
	"./kangaroo.png": "3acf",
	"./koala.png": "c554",
	"./lady-beetle.png": "35bd",
	"./leopard.png": "07fd",
	"./lion.png": "d98f",
	"./lizard.png": "582a",
	"./llama.png": "8f06",
	"./monkey.png": "f348",
	"./mosquito.png": "01196",
	"./mouse-face.png": "92a2",
	"./mouse.png": "b5ff",
	"./octopus.png": "1709",
	"./orangutan.png": "9ebd",
	"./owl.png": "5e4f",
	"./panda.png": "9f87",
	"./parrot.png": "30e4",
	"./peacock.png": "382d",
	"./penguin.png": "0a5b",
	"./pig-face.png": "4976",
	"./pig-nose.png": "a60a",
	"./pig.png": "ea06",
	"./polar-bear.png": "247b",
	"./poodle.png": "a504",
	"./rabbit-face.png": "c91b",
	"./rabbit.png": "df68",
	"./raccoon.png": "5158",
	"./ram.png": "0c2f",
	"./rhinoceros.png": "db71",
	"./rooster.png": "9a2f",
	"./sauropod.png": "ab7f",
	"./seal.png": "c921",
	"./shark.png": "2e1f",
	"./skunk.png": "d5aa",
	"./sloth.png": "7ef4",
	"./snail.png": "ab19",
	"./snake.png": "b066",
	"./spider.png": "b8d3",
	"./spiral-shell.png": "c54e",
	"./spouting-whale.png": "a1a3",
	"./swan.png": "7402",
	"./t-rex.png": "963a",
	"./tiger-face.png": "f676",
	"./tiger.png": "76fe",
	"./tooth.png": "1bfb",
	"./turkey.png": "2701",
	"./turtle.png": "43d0",
	"./unicorn.png": "679b",
	"./whale.png": "513e",
	"./wolf.png": "47d5",
	"./zebra.png": "180c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b60";